// extracted by mini-css-extract-plugin
module.exports = {"projects":"items-module--projects--3Pfy_","center":"items-module--center--2xKcp"};